import Icon from 'molecules/Icon';

import NavDropdownItem from 'components/Header/NavDropdownItem';
import styles from 'components/Header/NavMobilePanel/nav-mobile-panel.module.scss';

import type { NavMobileProps } from 'components/Header/NavMobile';
import type { MenuItem } from 'components/Header/headerTypes';
import type { FC } from 'react';

type NavMobilePanelProps = Pick<NavMobileProps, 'closePanels' | 'handleClick'> & {
  items: MenuItem[];
};

const NavMobilePanel: FC<NavMobilePanelProps> = ({ items, closePanels, handleClick }) => (
  <ul className={styles.panel}>
    {items &&
      items.map(({ subMenuItems = [] }, parentIndex) =>
        subMenuItems.map(({ label = '', url = '', isBold = false }, index) => {
          const isDivider = items.length > 0 && parentIndex !== items.length - 1 && index === subMenuItems.length - 1;

          return (
            <NavDropdownItem
              className={styles.mobileItem}
              key={label}
              title={label}
              link={url}
              handleClick={handleClick}
              data-testid={`dropdownItem--${label.toLowerCase()}`}
              modifiers={[isBold ? 'bold' : '', isDivider ? 'divider' : '']}
            />
          );
        }),
      )}
    <li>
      <button className={styles.back} onClick={closePanels}>
        <Icon icon="arrow-left" size={16} />
        Back
      </button>
    </li>
  </ul>
);

export default NavMobilePanel;
